// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"374fd4fb","499":"6784f3eb"}[chunkId] + ".chunk.js";
};